import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageSquare, FiExternalLink, FiCalendar, FiUser, FiSearch } = FiIcons;

const RedditSection = ({ redditPosts }) => {
  if (!redditPosts || redditPosts.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
      >
        <div className="flex items-center space-x-3 mb-6">
          <SafeIcon icon={FiMessageSquare} className="text-2xl text-purple-400" />
          <h3 className="text-2xl font-bold text-white">🎯 REDDIT ACTIVITY</h3>
        </div>
        
        <div className="text-center py-8">
          <SafeIcon icon={FiSearch} className="text-4xl text-orange-400 mx-auto mb-4" />
          <p className="text-purple-300">
            No Reddit activity found for this person. This could mean:
          </p>
          <ul className="text-purple-400 text-sm mt-4 space-y-2 text-left max-w-md mx-auto">
            <li>• The person doesn't use Reddit or uses a different username</li>
            <li>• Their Reddit activity is private or deleted</li>
            <li>• Search API credentials may be invalid</li>
            <li>• The username doesn't match their real name</li>
          </ul>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={FiMessageSquare} className="text-2xl text-purple-400" />
        <h3 className="text-2xl font-bold text-white">🎯 REDDIT ACTIVITY</h3>
        <span className="text-purple-300 text-sm ml-auto">
          {redditPosts.length} post{redditPosts.length !== 1 ? 's' : ''} found
        </span>
      </div>

      <div className="space-y-4">
        {redditPosts.map((post, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-black/30 rounded-lg p-6 border border-purple-500/20 hover:border-orange-400/40 transition-colors duration-300"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h4 className="text-lg font-semibold text-white mb-2">
                  {post.title}
                </h4>
                {post.subreddit && (
                  <div className="flex items-center space-x-2 mb-3">
                    <span className="px-2 py-1 bg-orange-500/20 text-orange-300 text-xs rounded-full">
                      r/{post.subreddit}
                    </span>
                    <span className="text-purple-400 text-sm">Reddit</span>
                  </div>
                )}
              </div>
              <SafeIcon icon={FiExternalLink} className="text-purple-400 flex-shrink-0" />
            </div>
            
            {post.summary && (
              <p className="text-purple-300 mb-3 text-sm line-clamp-3">{post.summary}</p>
            )}
            
            <div className="flex items-center justify-between text-sm">
              <a 
                href={post.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-400 hover:text-blue-300 truncate flex-1 mr-4"
              >
                {post.link}
              </a>
              <div className="flex items-center space-x-2 text-purple-400 flex-shrink-0">
                <SafeIcon icon={FiCalendar} className="text-sm" />
                <span>{post.date}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default RedditSection;